let initialized = false;

function ajaxUrl() {
    return (window.admin_ajax && (admin_ajax.url || admin_ajax[0])) || '/wp-admin/admin-ajax.php';
}

async function sendRequest(url, formdata) {
    const resp = await fetch(url, { method: 'POST', body: formdata });
    if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
    return resp.json();
}

function getMessage(resp, fallback = 'Something went wrong') {
    if (!resp) return fallback;
    const candidates = [
        resp.message,
        resp?.data?.message,
        Array.isArray(resp?.data) ? resp.data.join('\n') : undefined,
        typeof resp?.data === 'string' ? resp.data : undefined,
        resp?.error,
    ].filter(Boolean);
    const msg = candidates.find((v) => typeof v === 'string' && v.trim().length);
    return (msg || fallback).toString();
}

function toast(type, message) {
    if (window.levToast?.[type]) {
        window.levToast[type](message);
    } else {
        console[type === 'success' ? 'log' : 'error']('[toast]', message);
    }
}

export function initSwitchTeamModal() {
    if (initialized) return;
    initialized = true;

    // Submit handler – uses event delegation so it works after modal HTML is injected
    document.addEventListener('click', async (event) => {
        const button = event.target.closest('.my_account_switch_team_submit');
        if (!button) return;

        event.preventDefault();
        event.stopPropagation();

        const form = button.closest('form');
        if (!form) return;

        const formdata = new FormData(form);

        try {
            const resp = await sendRequest(ajaxUrl(), formdata);

            if (!resp || typeof resp !== 'object') {
                toast('error', 'Server returned invalid response');
                return;
            }

            if (resp.success) {
                toast('success', getMessage(resp, 'Team switched successfully. Reloading...'));
                button.closest('.levcharity_popup_modal')
                    ?.querySelector('.levcharity_modal_close_button')
                    ?.click();
                window.setTimeout(() => window.location.reload(), 2000);
                return;
            }

            toast('error', getMessage(resp, 'Something went wrong'));
        } catch (err) {
            console.error('[UH switch team] AJAX request failed', err);
            toast('error', err?.message || 'Something went wrong');
        }
    });
}

export function shouldInitSwitchTeamModal() {
    const portalPath = new URLSearchParams(window.location.search).get('_') || '';
    return Boolean(
        document.querySelector('.my_account_switch_team') ||
        document.querySelector('.my_account_teams_stats, .accounts_bar') ||
        document.getElementById('levcharity_my_account') ||
        document.body.classList.contains('woocommerce-account') ||
        document.body.classList.contains('levcharity-new-my-account') ||
        portalPath.includes('my-team')
    );
}
